import React, { useCallback, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { TextField } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { GoalCreationWizardContext } from '../goal-creation-wizard-context';
import { getStepStyles } from '../../../conversion-wizard-components/src/shared-styles/shared-content-style';
import { validateNumeric } from '../shared/validation-util';

const PageViewSettingUnstyled = (props) => {
  const {
    classes,
    updateGoalProps,
    showError,
    resetShowError,
  } = props;
  const i18n = useContext(I18nContext);
  const wizardContext = useContext(GoalCreationWizardContext);
  const [pageviewCount, setPageviewCount] = useState(wizardContext.goalContext.PageViews);
  const [pageviewErrorMsg, setPageviewErrorMsg] = useState('');

  const getErrorMessage = useCallback((value) => {
    if (_.isUndefined(value) || value.length === 0) {
      return i18n.getString(_TL_('Enter a page number'));
    }
    const parsedValue = parseInt(value, 10);
    if (_.isNaN(parsedValue) || parsedValue > 9999) {
      return i18n.getString(_TL_('Enter a valid page number between 0 and 9999'));
    }
    return '';
  }, [i18n]);

  const onChangePageViewCount = useCallback((event, value) => {
    if (validateNumeric(value) || value.length === 0) {
      setPageviewCount(value);
      setPageviewErrorMsg(getErrorMessage(value));
      const parsedValue = parseInt(value, 10);
      updateGoalProps({ PageViews: _.isNaN(parsedValue) ? undefined : parsedValue });
    }
  }, [getErrorMessage, updateGoalProps]);

  useEffect(() => {
    if (showError) {
      setPageviewErrorMsg(getErrorMessage(pageviewCount));
      resetShowError();
    }
  }, [getErrorMessage, pageviewCount, resetShowError, showError]);

  return (
    <div className="pageview-setting">
      <div className={classes.nonAccordionTitle}>
        <span className="title">{i18n.getString(_TL_('Pages per visit'))}</span>
        <HelpButton
          aria-label={i18n.getString(_TL_('Pages per visit'))}
          topic="pop_BA_UET_PerVisit"
        />
      </div>
      <p className={classes.bodyText}>{i18n.getString(_TL_('Greater than'))}</p>
      <TextField
        value={pageviewCount}
        onChange={onChangePageViewCount}
        styles={{ fieldGroup: { width: 180 } }}
      />
      {!_.isEmpty(pageviewErrorMsg) && (
        <div className="row" role="alert">
          <p className={classes.errorText}>{pageviewErrorMsg}</p>
        </div>
      )}
    </div>
  );
};

PageViewSettingUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getStepStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  updateGoalProps: PropTypes.func.isRequired,
  showError: PropTypes.bool.isRequired,
  resetShowError: PropTypes.func.isRequired,
};

export const PageViewSetting = withDefaultStyles(PageViewSettingUnstyled, getStepStyles);
